(() => {
  let loading = false;
  const startStopForm = document.querySelector('.startStop__form');
  const mainElement = document.querySelector('main');
  const messageElement = document.querySelector('.form__message');

  if (startStopForm) {
    const team = startStopForm.querySelector('#team');
    const road = startStopForm.querySelector('#road');
    const infoElement = startStopForm.querySelector('.startStop__messange__com strong');
    const timeElement = startStopForm.querySelector('.startStop__messange__info');

    startStopForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const teamValue = checkInput(team)
      const roadValue = road.value;
      const type = mainElement.dataset.type;
      const date = new Date;
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const min = date.getMinutes().toString().padStart(2, "0");
      const sek = date.getSeconds().toString().padStart(2, "0");
      const time = day + '.' + month + '.' + date.getFullYear() + ' ' + hour + ':' + min + ':' + sek;
      // console.log(time)
      messageElement.innerHTML = '';
      infoElement.innerHTML = '';
      timeElement.innerHTML = '';
      if (teamValue && roadValue && !loading) {
        loading = true;
        startStopForm.classList.add('loading');

        const data = new FormData();
        data.append('team', teamValue);
        data.append('road', roadValue);
        data.append('time', time);
        data.append('type', type);
        data.append('action', 'msm_startStop');

        fetch(my_ajax_object.ajaxurl, {
          method: 'post',
          body: data,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            loading = false;
            startStopForm.classList.remove('loading');
            if (!json.error) {
              infoElement.innerHTML = json.info;
              timeElement.innerHTML = json.time;
              setTimeout(() => {
                infoElement.innerHTML = '';
                timeElement.innerHTML = '';
              }, 8000);
            }
            else {
              messageElement.innerHTML = json.msg;
            }
          });

      }
    })
    if (team) {
      team.addEventListener('change', function (e) {
        checkInput(team)
      })
    }
  }


  function checkInput(element) {
    const errorElement = element.parentNode.querySelector('.form__error');
    if (!element.value) {
      errorElement.style.display = 'block';
      return false;
    }
    else {
      errorElement.style.display = 'none';
      return element.value;
    }
  }

})()